import { Button, Card, notification,Form, Tooltip } from 'antd'
import _ from 'lodash'
import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { chooseEmailModalFxn, DisplayDate } from '../../../../components/_utils/appUtils'
import { SendTemplateEmail } from '../../../email/actions'
import { getAllAbstracts } from '../actions'
import AbstractActivityList from '../AbstractActivityList'
import AbstractFilters from './AbstractFilters'
import ApprovalAbstractDrawer from '../abstractPages/ApprovalAbstractDrawer'
import { SendAbstractEmailAction } from '../../actions'
// import ApprovalAbstractDrawer from '../drawers/ApprovalAbstractDrawer'

@Form.create()
class RevisedAbstract extends Component {
  state = {
    filters: {},
    visibleDrawer: false,
    abstract: {},
    total: '',
    visibleActivityList: false
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let { dispatch } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'Revised Abstract'
      }
      let data = await dispatch(getAllAbstracts({ ...obj }))
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => { this.table.current.reload() }
  handleToReviewer = (record, e) => {
    let { dispatch } = this.props
    chooseEmailModalFxn({
      callback: async email => {
        let obj = {
          abstractId: record._id,
          fromEmail: email,
          emailType: 'revisedAbstractReviewer',
          template: 'revisedAbstractReviewer',
          model: 'Abstract',
          status:'Revised absrtact reviewer',
          type: 'abstract',
          reviewerId: record.selectedReviewer && record.selectedReviewer.length > 0
            ? record.selectedReviewer[0].reviewerId
            : null
        }
        let resp = await dispatch(SendAbstractEmailAction({
          email,
          id: record._id,
          obj,
          reviewerId: obj.reviewerId,
          template: obj.template
        }))
        if (resp && resp.success) {
          notification.success({ message: resp.message })
          this.reload()
        }
      }
    })
  }
  handleNotAsPerFormat = (record, e) => {
    let { dispatch } = this.props
    chooseEmailModalFxn({
      callback: async email => {
        let obj = {
          abstractId: record._id,
          fromEmail: email,
          emailType: 'revisedAbstractNotAsPerFormat',
          template: 'revisedAbstractNotAsPerFormat',
          model: 'Abstract',
          type: 'abstract',
          status: 'Not as per format'
        }
        let resp = await dispatch(SendAbstractEmailAction({ email, id: record._id, obj, template: obj.template }))
        if (resp && resp.success) {
          notification.success({ message: resp.message })
          this.reload()
        }
      }
    })
  }

  render() {
    const columns = [
      {
        title: 'Abstract Id',
        key: 'onlineAbstractId',
        dataIndex: 'onlineAbstractId',
        width: 100,
        render: (val, record) => <a href={`/abstract/view/${record._id}`}>{val}</a>
      },
      {
        title: 'Submitted Date',
        key: 'createdAt',
        width: 180,
        dataIndex: 'createdAt',
        render: item => DisplayDate(item)
      },
      {
        title: 'Title',
        key: 'titleOfAbstract',
        dataIndex: 'titleOfAbstract',
        render: item => item ? ReactHtmlParser(item) : null
      },
      {
        title: 'Comments Received',
        key: 'receiveDate',
        render: (item, record) => {
          return (record.selectedReviewer &&
            record.selectedReviewer[0] &&
            record.selectedReviewer[0].receiveDate)
            ? DisplayDate(record.selectedReviewer[0].receiveDate)
            : null;
        }
      },
      {
        title: 'Comments Send',
        key: 'sendToAuthorDate',
        width: 190,
        dataIndex: 'sendToAuthorDate',
        render: item => item ? DisplayDate(item) : null
      },
      {
        title: 'Revised Abstract Date',
        key: 'revisedAbstractDate',
        width: 190,
        dataIndex: 'revisedAbstractDate',
        render: item => item ? DisplayDate(item) : null
      },
      {
        title: 'Action',
        key: 'Action',
        width: 280,
        render: (item, record) => {
          return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
              {/* Row 1 */}
              <div style={{ width: '100%', marginBottom: '5px' }}>
                <Button
                  onClick={e => this.handleNotAsPerFormat(record, e)}
                  className={'roundSmallBtn'}>
                  Not as per format
                </Button>
                <Button
                  onClick={e => this.handleToReviewer(record, e)}
                  className={'roundSmallBtn'}>
                  To Reviewer
                </Button>
              </div>

              {/* Row 2 */}
              <div style={{ width: '100%' }}>
                <Button
                  className={'roundSmallBtn'}
                  onClick={() =>
                    this.setState({ visibleDrawer: true, abstract: record })
                  }>
                  Approval
                </Button>
                <Button
                  className={'roundSmallBtn'}
                  onClick={() =>
                    this.setState({ visibleActivityList: true, abstract: record })
                  }>
                  Activities
                </Button>
              </div>
            </div>
          )
        }
      }    ]

    return (
      <PageHeaderWrapper title={`Revised Abstracts (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters callback={data => this.setState({ filters: data }, this.reload)} />
          <TableComp ref={this.table} columns={columns} apiRequest={this.apiRequest} />
        </Card>

        {/*{this.state.visibleDrawer && (*/}
        {/*  <ApprovalAbstractDrawer*/}
        {/*    visible={this.state.visibleDrawer}*/}
        {/*    abstractId={this.state.abstract._id}*/}
        {/*    abstract={this.state.abstract}*/}
        {/*    onClose={() => this.setState({ visibleDrawer: false })}*/}
        {/*    callback={this.reload}*/}
        {/*  />*/}
        {/*)}*/}
        {this.state.visibleDrawer && (
          <ApprovalAbstractDrawer
            visible={this.state.visibleDrawer}
            abstractId={this.state.abstract._id}
            abstract={this.state.abstract}
            onClose={() => this.setState({ visibleDrawer: false })}
            callback={this.reload} // This will trigger the table to refresh after submission
          />
        )}
        {this.state.visibleActivityList && (
          <AbstractActivityList
            abstractId={this.state.abstract._id}
            visible={this.state.visibleActivityList}
            onClose={() => this.setState({ visibleActivityList: false })}
          />
        )}
      </PageHeaderWrapper>
    )
  }
}

export default connect(null)(RevisedAbstract)
